import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useRef } from 'react';
import { DayPickerRangeController } from 'react-dates';
import moment from 'moment';
import { DatePickerRangeHeader, DatePickerNavigation, DatePickerDay } from '@elliemae/ds-date-picker';
import ChevronLeft from '@elliemae/ds-icons/ChevronLeft';
import { aggregatedClasses, convertPropToCssClassName } from '@elliemae/ds-classnames';

var blockname = 'date-range';
var Wrapper = aggregatedClasses('div')(blockname, 'wrapper');

var _convertPropToCssClas = convertPropToCssClassName('datepicker'),
    classNameElement = _convertPropToCssClas.classNameElement,
    classNameBlock = _convertPropToCssClas.classNameBlock;

var START_DATE = 'startDate';
var END_DATE = 'endDate';

var DatePickerRangeDate = function DatePickerRangeDate(_ref) {
  var dateStart = _ref.dateStart,
      dateEnd = _ref.dateEnd,
      _ref$displayFormatDay = _ref.displayFormatDay,
      displayFormatDay = _ref$displayFormatDay === void 0 ? 'D' : _ref$displayFormatDay,
      _ref$showHeader = _ref.showHeader,
      showHeader = _ref$showHeader === void 0 ? true : _ref$showHeader,
      otherProps = _ref.otherProps;

  var _useState = useState(dateStart),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDateStart = _useState2[0],
      setSelectedDateStart = _useState2[1];

  var _useState3 = useState(dateEnd),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedDateEnd = _useState4[0],
      setSelectedDateEnd = _useState4[1];

  var _useState5 = useState(START_DATE),
      _useState6 = _slicedToArray(_useState5, 2),
      focusedInput = _useState6[0],
      setFocusedInput = _useState6[1];

  var datePickerRef = useRef();

  var handleFocusChange = function handleFocusChange() {
    setFocusedInput(focusedInput === START_DATE ? END_DATE : START_DATE);
  };

  var handleDatesChange = function handleDatesChange(_ref2) {
    var startDate = _ref2.startDate,
        endDate = _ref2.endDate;
    setSelectedDateStart(startDate);
    setSelectedDateEnd(endDate);
  };

  var handleStartInputChange = function handleStartInputChange(newDate) {
    setSelectedDateStart(newDate);
  };

  var handleEndInputChange = function handleEndInputChange(newDate) {
    setSelectedDateEnd(newDate);
  };

  var getSafeDateStartValue = function getSafeDateStartValue() {
    if (selectedDateStart) {
      return moment(selectedDateStart);
    }
  };

  var getSafeDateEndValue = function getSafeDateEndValue() {
    if (selectedDateEnd) {
      return moment(selectedDateEnd);
    }
  };

  var safeStartDate = getSafeDateStartValue();
  var safeEndDate = getSafeDateEndValue();
  return /*#__PURE__*/React.createElement(Wrapper, null, showHeader && /*#__PURE__*/React.createElement(DatePickerRangeHeader, {
    onEndInputChange: handleEndInputChange,
    onStartInputChange: handleStartInputChange,
    selectedEndDate: safeEndDate,
    selectedStartDate: safeStartDate
  }), /*#__PURE__*/React.createElement("div", {
    ref: datePickerRef,
    className: classNameBlock('wrapper-day-picker-single-date-controller')
  }, /*#__PURE__*/React.createElement(DayPickerRangeController, _extends({}, otherProps, {
    enableOutsideDays: true,
    endDate: safeEndDate,
    focused: true,
    focusedInput: focusedInput,
    hideKeyboardShortcutsPanel: true,
    navNext: /*#__PURE__*/React.createElement(DatePickerNavigation, {
      className: classNameElement('navigation-next')
    }),
    navPrev: /*#__PURE__*/React.createElement(DatePickerNavigation, {
      className: classNameElement('navigation-prev'),
      icon: ChevronLeft
    }),
    onDatesChange: handleDatesChange,
    onFocusChange: handleFocusChange,
    renderDayContents: function renderDayContents(date) {
      return /*#__PURE__*/React.createElement(DatePickerDay, {
        className: classNameElement('day-contents'),
        date: date.format(displayFormatDay)
      });
    },
    startDate: safeStartDate
  }))));
};

export default DatePickerRangeDate;
//# sourceMappingURL=DatePickerRange.js.map
